import React, { useEffect } from "react";
import { Container } from "reactstrap";
import "../../styles/common-section.css";

import AOS from 'aos';
import "aos/dist/aos.css";

const CommonSection = ({ title }) => {
  useEffect(()=>{
    AOS.init({duration: 800});
  },[]);
  return (
    <section className="common__section mb-5 mt-3" data-aos="fade-up">
      <Container className="text-center">
        <h1 className="text-light">{title}</h1>
      </Container>
    </section>
  );
};

export default CommonSection;
